import React from 'react';
import { useTranslation } from 'react-i18next';
import ForgotPasswordForm from './components/ForgotPasswordForm';

const ForgotPassword = () => {
  const { t } = useTranslation();
  return (
    <div className="forgot-password">
      <div className="forgot-password__wrapper">
        <h1 className="forgot-password__title">{t('forgot_password_title')}</h1>
        <span className="headline forgot-password__subtitle">{t('forgot_password_subtitle')}</span>
        <ForgotPasswordForm />
      </div>
    </div>
  );
};

export default ForgotPassword;
